<template>
  <div class="wordingDescription contents" data-editor-active>
    <h3 class="title" ref="title" data-grid-layout="title">용어설명</h3>
    <div class="keywords" data-grid-layout="content">
      <div ref="namo" class="textEditorWrap" id="namoKeywordEditor" v-html="this.contentText" ></div>
    </div>
  </div>
</template>
<script>

const defaultTable = `
  <table cellspacing="0" cellpadding="0" border="1" style="width: 1120px; height: 90px; font-size: 10pt; border-width: 0px; border-color: rgb(221, 221, 221); border-collapse: collapse; border-style: solid; background-color: rgb(255, 255, 255);"> 
    <tbody> 
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">한글명칭</p></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">영문명칭</p></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid; background-color: rgb(245, 245, 245);"><p style="text-align: center;">설명</p></td> 
      </tr> 
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
      </tr>
      <tr> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td> 
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
        <td style="width: 372px; height: 30px; border-width: 1px; border-color: rgb(221, 221, 221); border-style: solid;"></td>
      </tr>
    </tbody> 
  </table>
`

export default {
  props: {
    item: { type: Object, default: {} },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      contentText: '',
    }
  },
  async mounted() {
    if(!this.item.content || this.item.content == '' || this.item.content == "\"<p><br></p>\"") {
      this.contentText = defaultTable;
    } else {
      this.contentText = this.item.content;
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import './wikiContent.scss';
</style>
